module.exports = "https://health.dajiuxing.com.cn/img/assets/rightsDetails/chronicDisease/fwqybtr.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FrightsDetails%2FchronicDisease%2Ffwqybtr.png
// module id = qL8o
// module chunks = 93